import React from "react";
import { Box, Card, CardContent, Grid, Typography, Skeleton } from "@mui/material";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import PendingIcon from "@mui/icons-material/Pending";

function EarningsStatsCards({ stats, loading }) {
  const statsConfig = [
    {
      title: "Total Approved Earnings",
      value: stats?.total_approved_earnings || 0,
      icon: <TrendingUpIcon sx={{ fontSize: 40 }} />,
      color: "primary.main",
      bgColor: "primary.light",
      count: stats?.approved_count || 0,
    },
    {
      title: "Paid Earnings",
      value: stats?.total_paid_earnings || 0,
      icon: <AccountBalanceWalletIcon sx={{ fontSize: 40 }} />,
      color: "success.main",
      bgColor: "success.light",
      count: stats?.paid_count || 0,
    },
    {
      title: "Upcoming Earnings",
      value: stats?.total_upcoming_earnings || 0,
      icon: <HourglassEmptyIcon sx={{ fontSize: 40 }} />,
      color: "warning.main",
      bgColor: "warning.light",
      count: stats?.upcoming_count || 0,
      subtitle: "Approved but not paid",
    },
    {
      title: "Unapproved Earnings",
      value: stats?.total_unapproved_earnings || 0,
      icon: <PendingIcon sx={{ fontSize: 40 }} />,
      color: "error.main",
      bgColor: "error.light",
      count: stats?.unapproved_count || 0,
      subtitle: "Pending approval",
    },
  ];

  if (loading) {
    return (
      <Grid container spacing={2} mb={3}>
        {[1, 2, 3, 4].map((item) => (
          <Grid item xs={12} sm={6} md={3} key={item}>
            <Card elevation={3}>
              <CardContent>
                <Skeleton variant="text" width="60%" height={30} />
                <Skeleton variant="text" width="80%" height={50} />
                <Skeleton variant="text" width="40%" height={20} />
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    );
  }

  return (
    <Grid container spacing={2} mb={3}>
      {statsConfig.map((stat, index) => (
        <Grid item xs={12} sm={6} md={3} key={index}>
          <Card
            elevation={3}
            sx={{
              height: "100%",
              transition: "transform 0.2s",
              "&:hover": {
                transform: "translateY(-4px)",
                boxShadow: 6,
              },
            }}
          >
            <CardContent>
              <Box display="flex" justifyContent="space-between" alignItems="flex-start">
                <Box flex={1}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                    sx={{ fontWeight: 500 }}
                  >
                    {stat.title}
                  </Typography>
                  <Typography
                    variant="h4"
                    sx={{
                      fontWeight: "bold",
                      color: stat.color,
                      mb: 0.5,
                    }}
                  >
                    ${stat.value.toFixed(2)}
                  </Typography>
                  <Typography variant="caption" color="text.secondary">
                    {stat.count} transaction{stat.count !== 1 ? "s" : ""}
                  </Typography>
                  {stat.subtitle && (
                    <Typography
                      variant="caption"
                      display="block"
                      color="text.secondary"
                      sx={{ fontStyle: "italic", mt: 0.5 }}
                    >
                      {stat.subtitle}
                    </Typography>
                  )}
                </Box>
                <Box
                  sx={{
                    color: stat.bgColor,
                    borderRadius: 2,
                    p: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {stat.icon}
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
}

export default EarningsStatsCards;
